import type { placeManualDigsite } from '../shared/random-generator-browser';

/** Stateless cross-bundle bridge: the early-card generator owns its pending/retry command. */
export async function tryPlaceManualDigsite(payload: Record<string, unknown>): Promise<string | null> {
    const destination = String(payload.encounter_id || payload.location_id || '');
    if (!destination) return null;
    const place = (window as Window & { ftPlaceManualDigsite: typeof placeManualDigsite }).ftPlaceManualDigsite;
    const id = await place(payload, destination);
    return id ? `<span hidden data-ft-added-encounter-inventory-id="${id}"></span>` : null;
}
